(function () {
    'use strict';

    angular
        .module('app')
        .controller('PaginationController', PaginationController);

    PaginationController.$inject = ['$scope', '$rootScope'];

    function PaginationController($scope, $rootScope) {
        var vm = this;
        vm.$onInit = init;
        vm.setPage = setPage;

        $scope.$watch('total', function (newValue, oldValue, scope) {
            vm.pager = setup(vm.total, vm.page, vm.size);
        });

        $rootScope.$on('update_pagination', function (event, args) {
            vm.total = args.total;
            vm.page = args.page;
            vm.size = args.size;
            vm.pager = setup(vm.total, vm.page, vm.size);
            $scope.$applyAsync();
        });

        function init() {
            vm.pager = setup(vm.total, vm.page, vm.size);
        }

        function setPage(page) {
            if (page <= vm.pager.totalPages) {
                vm.page = page;
                vm.pager.currentPage = page;
                vm.update(page);
                vm.pager = setup(vm.total, vm.page, vm.size);
            }
        }

        function range(start, end) {
            return [...Array(end - start).keys()].map(i => i + start);
        }

        function setup(totalItems, currentPage, pageSize) {
            currentPage = parseInt(currentPage) || 1;
            pageSize = parseInt(pageSize) || 10;
            var totalPages = Math.ceil(parseInt(totalItems) / pageSize);
            var startPage, endPage;

            if (totalPages <= 6) {
                startPage = 1;
                endPage = totalPages;
            } else {
                if (currentPage <= 3) {
                    startPage = 1;
                    endPage = 5;
                } else if (currentPage + 2 >= totalPages) {
                    startPage = totalPages - 5;
                    endPage = totalPages;
                } else {
                    startPage = currentPage - 2;
                    endPage = currentPage + 2;
                }
            }

            var startIndex = (currentPage - 1) * pageSize;
            var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
            var pages = range(startPage, endPage + 1);

            return {
                totalItems: totalItems,
                currentPage: currentPage,
                pageSize: pageSize,
                totalPages: totalPages,
                startPage: startPage,
                endPage: endPage,
                startIndex: startIndex,
                endIndex: endIndex,
                pages: pages
            };
        }
    }
})();